import { default as _91_46_46_46slug_93bNkhvM6RzhMeta } from "/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/[...slug].vue?macro=true";
import { default as editQSok49aniEMeta } from "/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/application/edit.vue?macro=true";
import { default as indexdB0gAlFhHsMeta } from "/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/application/index.vue?macro=true";
import { default as indexki6VlYoiBoMeta } from "/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/auth/index.vue?macro=true";
import { default as downloadbDSURJceBDMeta } from "/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/download.vue?macro=true";
import { default as indexcknyFVzB1ZMeta } from "/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/index.vue?macro=true";
import { default as indexQBC3BRMS1TMeta } from "/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/myjuleica/index.vue?macro=true";
import { default as userEhwshmbNa3Meta } from "/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/myjuleica/user.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93bNkhvM6RzhMeta?.name ?? "slug",
    path: _91_46_46_46slug_93bNkhvM6RzhMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93bNkhvM6RzhMeta || {},
    alias: _91_46_46_46slug_93bNkhvM6RzhMeta?.alias || [],
    redirect: _91_46_46_46slug_93bNkhvM6RzhMeta?.redirect || undefined,
    component: () => import("/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: editQSok49aniEMeta?.name ?? "application-edit",
    path: editQSok49aniEMeta?.path ?? "/application/edit",
    meta: editQSok49aniEMeta || {},
    alias: editQSok49aniEMeta?.alias || [],
    redirect: editQSok49aniEMeta?.redirect || undefined,
    component: () => import("/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/application/edit.vue").then(m => m.default || m)
  },
  {
    name: indexdB0gAlFhHsMeta?.name ?? "application",
    path: indexdB0gAlFhHsMeta?.path ?? "/application",
    meta: indexdB0gAlFhHsMeta || {},
    alias: indexdB0gAlFhHsMeta?.alias || [],
    redirect: indexdB0gAlFhHsMeta?.redirect || undefined,
    component: () => import("/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/application/index.vue").then(m => m.default || m)
  },
  {
    name: indexki6VlYoiBoMeta?.name ?? "auth",
    path: indexki6VlYoiBoMeta?.path ?? "/auth",
    meta: indexki6VlYoiBoMeta || {},
    alias: indexki6VlYoiBoMeta?.alias || [],
    redirect: indexki6VlYoiBoMeta?.redirect || undefined,
    component: () => import("/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/auth/index.vue").then(m => m.default || m)
  },
  {
    name: downloadbDSURJceBDMeta?.name ?? "download",
    path: downloadbDSURJceBDMeta?.path ?? "/download",
    meta: downloadbDSURJceBDMeta || {},
    alias: downloadbDSURJceBDMeta?.alias || [],
    redirect: downloadbDSURJceBDMeta?.redirect || undefined,
    component: () => import("/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/download.vue").then(m => m.default || m)
  },
  {
    name: indexcknyFVzB1ZMeta?.name ?? "index",
    path: indexcknyFVzB1ZMeta?.path ?? "/",
    meta: indexcknyFVzB1ZMeta || {},
    alias: indexcknyFVzB1ZMeta?.alias || [],
    redirect: indexcknyFVzB1ZMeta?.redirect || undefined,
    component: () => import("/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexQBC3BRMS1TMeta?.name ?? "myjuleica",
    path: indexQBC3BRMS1TMeta?.path ?? "/myjuleica",
    meta: indexQBC3BRMS1TMeta || {},
    alias: indexQBC3BRMS1TMeta?.alias || [],
    redirect: indexQBC3BRMS1TMeta?.redirect || undefined,
    component: () => import("/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/myjuleica/index.vue").then(m => m.default || m)
  },
  {
    name: userEhwshmbNa3Meta?.name ?? "myjuleica-user",
    path: userEhwshmbNa3Meta?.path ?? "/myjuleica/user",
    meta: userEhwshmbNa3Meta || {},
    alias: userEhwshmbNa3Meta?.alias || [],
    redirect: userEhwshmbNa3Meta?.redirect || undefined,
    component: () => import("/home/forge/juleica.de/releases/20251006133937/client-frontend/pages/myjuleica/user.vue").then(m => m.default || m)
  }
]